var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.titleText))]),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }